import { i18n } from 'i18next';

const translateService = () => {
  let state: i18n = {} as i18n;
  return {
    get: () => state,
    set: (value: i18n) => {
      state = value;
      return value;
    }
  };
};

export default translateService();
